"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationBetween = exports.DifferenceBetween = exports.doBefore = exports.doAfter = exports.TimezoneOffsetFrom = exports.TimeFrom = exports.DateFrom = exports.DateTimeComponentFrom = exports.TimeOfDay = exports.Now = exports.Today = exports.Time = exports.Date = exports.DateTime = void 0;
/* eslint-disable @typescript-eslint/ban-ts-comment */
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var literal_1 = require("./literal");
var DT = __importStar(require("../datatypes/datatypes"));
var DateTime = /** @class */ (function (_super) {
    __extends(DateTime, _super);
    function DateTime(json) {
        var _this = _super.call(this, json) || this;
        _this.json = json;
        return _this;
    }
    DateTime.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, property, args;
            var _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        for (_i = 0, _a = DateTime.PROPERTIES; _i < _a.length; _i++) {
                            property = _a[_i];
                            // if json does not contain 'timezoneOffset' set it to the executionDateTime from the context
                            if (this.json[property] != null) {
                                // @ts-ignore
                                this[property] = (0, builder_1.build)(this.json[property]);
                            }
                            else if (property === 'timezoneOffset' && ctx.getTimezoneOffset() != null) {
                                // @ts-ignore
                                this[property] = literal_1.Literal.from({
                                    type: 'Literal',
                                    value: ctx.getTimezoneOffset(),
                                    valueType: '{urn:hl7-org:elm-types:r1}Integer'
                                });
                            }
                        }
                        return [4 /*yield*/, Promise.all(
                            // @ts-ignore
                            DateTime.PROPERTIES.map(function (p) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                return [2 /*return*/, (this[p] != null ? this[p].execute(ctx) : undefined)];
                            }); }); }))];
                    case 1:
                        args = _c.sent();
                        return [2 /*return*/, new ((_b = DT.DateTime).bind.apply(_b, __spreadArray([void 0], args, false)))()];
                }
            });
        });
    };
    DateTime.PROPERTIES = [
        'year',
        'month',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
        'timezoneOffset'
    ];
    return DateTime;
}(expression_1.Expression));
exports.DateTime = DateTime;
var Date = /** @class */ (function (_super) {
    __extends(Date, _super);
    function Date(json) {
        var _this = _super.call(this, json) || this;
        _this.json = json;
        return _this;
    }
    Date.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, property, args;
            var _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        for (_i = 0, _a = Date.PROPERTIES; _i < _a.length; _i++) {
                            property = _a[_i];
                            if (this.json[property] != null) {
                                // @ts-ignore
                                this[property] = (0, builder_1.build)(this.json[property]);
                            }
                        }
                        return [4 /*yield*/, Promise.all(
                            // @ts-ignore
                            Date.PROPERTIES.map(function (p) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                return [2 /*return*/, (this[p] != null ? this[p].execute(ctx) : undefined)];
                            }); }); }))];
                    case 1:
                        args = _c.sent();
                        return [2 /*return*/, new ((_b = DT.Date).bind.apply(_b, __spreadArray([void 0], args, false)))()];
                }
            });
        });
    };
    Date.PROPERTIES = ['year', 'month', 'day'];
    return Date;
}(expression_1.Expression));
exports.Date = Date;
var Time = /** @class */ (function (_super) {
    __extends(Time, _super);
    function Time(json) {
        var _this = _super.call(this, json) || this;
        for (var _i = 0, _a = Time.PROPERTIES; _i < _a.length; _i++) {
            var property = _a[_i];
            if (json[property] != null) {
                // @ts-ignore
                _this[property] = (0, builder_1.build)(json[property]);
            }
        }
        return _this;
    }
    Time.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args;
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all(
                        // @ts-ignore
                        Time.PROPERTIES.map(function (p) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, (this[p] != null ? this[p].execute(ctx) : undefined)];
                        }); }); }))];
                    case 1:
                        args = _b.sent();
                        return [2 /*return*/, new ((_a = DT.DateTime).bind.apply(_a, __spreadArray([void 0, 0, 1, 1], args, false)))().getTime()];
                }
            });
        });
    };
    Time.PROPERTIES = ['hour', 'minute', 'second', 'millisecond'];
    return Time;
}(expression_1.Expression));
exports.Time = Time;
var Today = /** @class */ (function (_super) {
    __extends(Today, _super);
    function Today(json) {
        return _super.call(this, json) || this;
    }
    Today.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ctx.getExecutionDateTime().getDate()];
            });
        });
    };
    return Today;
}(expression_1.Expression));
exports.Today = Today;
var Now = /** @class */ (function (_super) {
    __extends(Now, _super);
    function Now(json) {
        return _super.call(this, json) || this;
    }
    Now.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ctx.getExecutionDateTime()];
            });
        });
    };
    return Now;
}(expression_1.Expression));
exports.Now = Now;
var TimeOfDay = /** @class */ (function (_super) {
    __extends(TimeOfDay, _super);
    function TimeOfDay(json) {
        return _super.call(this, json) || this;
    }
    TimeOfDay.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ctx.getExecutionDateTime().getTime()];
            });
        });
    };
    return TimeOfDay;
}(expression_1.Expression));
exports.TimeOfDay = TimeOfDay;
var DateTimeComponentFrom = /** @class */ (function (_super) {
    __extends(DateTimeComponentFrom, _super);
    function DateTimeComponentFrom(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision;
        return _this;
    }
    DateTimeComponentFrom.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg != null) {
                            return [2 /*return*/, arg[this.precision.toLowerCase()]];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return DateTimeComponentFrom;
}(expression_1.Expression));
exports.DateTimeComponentFrom = DateTimeComponentFrom;
var DateFrom = /** @class */ (function (_super) {
    __extends(DateFrom, _super);
    function DateFrom(json) {
        return _super.call(this, json) || this;
    }
    DateFrom.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var date;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        date = _a.sent();
                        if (date != null) {
                            return [2 /*return*/, date.getDate()];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return DateFrom;
}(expression_1.Expression));
exports.DateFrom = DateFrom;
var TimeFrom = /** @class */ (function (_super) {
    __extends(TimeFrom, _super);
    function TimeFrom(json) {
        return _super.call(this, json) || this;
    }
    TimeFrom.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var date;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        date = _a.sent();
                        if (date != null) {
                            return [2 /*return*/, date.getTime()];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return TimeFrom;
}(expression_1.Expression));
exports.TimeFrom = TimeFrom;
var TimezoneOffsetFrom = /** @class */ (function (_super) {
    __extends(TimezoneOffsetFrom, _super);
    function TimezoneOffsetFrom(json) {
        return _super.call(this, json) || this;
    }
    TimezoneOffsetFrom.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var date;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        date = _a.sent();
                        if (date != null) {
                            return [2 /*return*/, date.timezoneOffset];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return TimezoneOffsetFrom;
}(expression_1.Expression));
exports.TimezoneOffsetFrom = TimezoneOffsetFrom;
// Delegated to by overloaded#After
function doAfter(a, b, precision) {
    return a.after(b, precision);
}
exports.doAfter = doAfter;
// Delegated to by overloaded#Before
function doBefore(a, b, precision) {
    return a.before(b, precision);
}
exports.doBefore = doBefore;
var DifferenceBetween = /** @class */ (function (_super) {
    __extends(DifferenceBetween, _super);
    function DifferenceBetween(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision;
        return _this;
    }
    DifferenceBetween.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        // Check to make sure args exist and that they have differenceBetween functions so that they can be compared to one another
                        if (args[0] == null ||
                            args[1] == null ||
                            typeof args[0].differenceBetween !== 'function' ||
                            typeof args[1].differenceBetween !== 'function') {
                            return [2 /*return*/, null];
                        }
                        result = args[0].differenceBetween(args[1], this.precision != null ? this.precision.toLowerCase() : undefined);
                        if (result != null && result.isPoint()) {
                            return [2 /*return*/, result.low];
                        }
                        else {
                            return [2 /*return*/, result];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return DifferenceBetween;
}(expression_1.Expression));
exports.DifferenceBetween = DifferenceBetween;
var DurationBetween = /** @class */ (function (_super) {
    __extends(DurationBetween, _super);
    function DurationBetween(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision;
        return _this;
    }
    DurationBetween.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        // Check to make sure args exist and that they have durationBetween functions so that they can be compared to one another
                        if (args[0] == null ||
                            args[1] == null ||
                            typeof args[0].durationBetween !== 'function' ||
                            typeof args[1].durationBetween !== 'function') {
                            return [2 /*return*/, null];
                        }
                        result = args[0].durationBetween(args[1], this.precision != null ? this.precision.toLowerCase() : undefined);
                        if (result != null && result.isPoint()) {
                            return [2 /*return*/, result.low];
                        }
                        else {
                            return [2 /*return*/, result];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return DurationBetween;
}(expression_1.Expression));
exports.DurationBetween = DurationBetween;
//# sourceMappingURL=datetime.js.map